<header class="plano-cabecalho" data-testid="plano-cabecalho">
  <app-trilha-navegacao [passos]="passos()" />

  <div class="plano-cabecalho__linha">
    <div class="plano-cabecalho__identificacao">
      <div class="plano-cabecalho__titulo-linha">
        <h1 class="plano-cabecalho__titulo" data-testid="plano-cabecalho-nome">{{ plano().nome }}</h1>
        <vivest-tag type="status" [variant]="varianteStatus()" data-testid="plano-cabecalho-status">
          {{ plano().status }}
        </vivest-tag>
      </div>

      <dl class="plano-cabecalho__dados">
        <div class="plano-cabecalho__dado">
          <dt>Código:</dt>
          <dd data-testid="plano-cabecalho-codigo">{{ plano().codigo }}</dd>
        </div>
        <div class="plano-cabecalho__dado">
          <dt>Tipo do Plano:</dt>
          <dd data-testid="plano-cabecalho-tipo">{{ tipo() }}</dd>
        </div>
        <div class="plano-cabecalho__dado">
          <dt>Última atualização:</dt>
          <dd data-testid="plano-cabecalho-atualizacao">{{ ultimaAtualizacao() }}</dd>
        </div>
      </dl>
    </div>

    <vivest-button
      variant="outline"
      size="md"
      data-testid="plano-cabecalho-voltar"
      (click)="voltar.emit()"
    >
      <vivest-icon slot="icon-left" name="arrow-left" source="feather"></vivest-icon>
      {{ rotuloVoltar() }}
    </vivest-button>
  </div>
</header>
